import { useRef } from "react";

/**
 * Horizontal scroller shared by the home rows and the cast list.
 * `arrows` lets the home row pass its custom SVG chevrons.
 */
const Carousel = ({
  children,
  step = 500,
  className = "",
  arrowClassName = "h-[170px] sm:h-[230px] md:h-[300px]",
  renderNext,
  renderPrev,
}) => {
  const track = useRef(null);
  const scrollBy = (amount) =>
    track.current?.scrollBy({ left: amount, behavior: "smooth" });

  return (
    <div className={`group relative w-full ${className}`}>
      <button
        type="button"
        aria-label="بعدی"
        onClick={() => scrollBy(step)}
        className={`absolute right-0 top-0 z-50 hidden cursor-pointer items-center justify-center px-6 opacity-75 sm:flex ${arrowClassName} linear-div`}
      >
        {renderNext ? renderNext() : null}
      </button>

      <div
        ref={track}
        className="scrollbar-hide h-full w-full overflow-x-scroll scroll-smooth whitespace-nowrap"
      >
        {children}
      </div>

      <button
        type="button"
        aria-label="قبلی"
        onClick={() => scrollBy(-step)}
        className={`absolute left-0 top-0 z-50 hidden cursor-pointer items-center justify-center px-6 opacity-75 sm:flex ${arrowClassName} linear-div`}
      >
        {renderPrev ? renderPrev() : null}
      </button>
    </div>
  );
};

export default Carousel;
